import { ImagePreloadState } from './state'
import { GetterTreeWithRootState } from '~/store/types'

export default {} as GetterTreeWithRootState<ImagePreloadState>
